import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { SkeletonButton, SkeletonText, SkeletonTitle } from '@/components/ui/skeleton-base'
import { Skeleton } from '@/components/ui/skeleton'

export const MastercardEditSkeleton = () => {
    return (
        <div className="container mx-auto py-8">
            {/* Header */}
            <div className="mb-6 flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <Skeleton className="h-10 w-10" />
                    <SkeletonTitle className="w-64" />
                </div>
                <div className="flex gap-2">
                    <SkeletonButton />
                    <SkeletonButton />
                </div>
            </div>

            <div className="space-y-6">
                {/* General Settings Card */}
                <Card className="mb-6">
                    <CardHeader>
                        <CardTitle>
                            <SkeletonText className="w-40" />
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div>
                            <SkeletonText className="mb-2 w-16" />
                            <Skeleton className="h-10 w-full" />
                        </div>
                        <div className="flex items-center space-x-2">
                            <Skeleton className="h-5 w-5" />
                            <SkeletonText className="w-20" />
                        </div>
                    </CardContent>
                </Card>

                {/* API Credentials Card */}
                <Card className="mb-6">
                    <CardHeader>
                        <CardTitle>
                            <SkeletonText className="w-36" />
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <SkeletonText className="mb-4 w-3/4" />
                        <div>
                            <SkeletonText className="mb-2 w-20" />
                            <Skeleton className="h-10 w-full" />
                        </div>
                        <div>
                            <SkeletonText className="mb-2 w-28" />
                            <Skeleton className="h-10 w-full" />
                        </div>
                        <div>
                            <SkeletonText className="mb-2 w-32" />
                            <Skeleton className="h-10 w-full" />
                        </div>
                    </CardContent>
                </Card>

                {/* Test Mode Settings Card */}
                <Card className="mb-6">
                    <CardHeader>
                        <CardTitle>
                            <SkeletonText className="w-40" />
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div className="flex items-center space-x-2">
                            <Skeleton className="h-5 w-5" />
                            <SkeletonText className="w-36" />
                        </div>
                    </CardContent>
                </Card>

                {/* Descriptor Settings Card */}
                <Card className="mb-6">
                    <CardHeader>
                        <CardTitle>
                            <SkeletonText className="w-44" />
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div>
                            <SkeletonText className="mb-2 w-44" />
                            <Skeleton className="h-10 w-full" />
                        </div>
                        <div>
                            <SkeletonText className="mb-2 w-20" />
                            <Skeleton className="h-10 w-full" />
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    )
}

